import { OptimizerContext } from '@/optimizer/optimizerContext';
import { useContext } from 'use-context-selector';

export const useInitOptimizerServiceManager = () => {
    const context = useContext(OptimizerContext);

    if (!context) {
        throw new Error(
            'useInitOptimizerServiceManager must be used within a PyOptimizerContextProvider',
        );
    }

    return context.initOptimizerServiceManager;
};
